<template>
    <div class="tsa-certificateServiceFeeDialog" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <p class="close el-icon-close" @click="close"></p>
            <div class="top">
                <p>{{ title }}</p>
                <img v-if="free" src="../../../../assets/images/free.png" alt="">
            </div>
            <div class="center">
                <div class="certificate-container">
                    <div class="item" @click="preview(chineseCertificate)">
                        <img :src="chineseCertificate" alt="">
                        <p>中文证书样例</p>
                    </div>
                    <div class="item" @click="preview(englishCertificate)">
                        <img :src="englishCertificate" alt="">
                        <p>英文证书样例</p>
                    </div>
                </div>
                <div class="free-container" v-if="free">
                    <p>本作品中申请文件消耗的时间戳总数已达{{ minFileTsCount }}个，生成版权认证证书<span>限时免费</span></p>
                </div>
                <div class="pay-container" v-else>
                    <p>1.申请《{{name}}》版权认证证书，需消耗{{ tsCount }}个时间戳。</p>
                    <p>2.权利人、作品名称、作品类型、申请人自述声明、认证材料等信息由申请人自行填写，平台不对真实性进行审查、不承担相关法律责任。</p>
                </div>
            </div>
            <div class="btn-group">
                <div class="btn">
                    <TsaButton plain @click="cancel" type="default" size="small">{{ cancelButtonText }}</TsaButton>
                </div>
                <div class="btn">
                    <TsaButton :loading="loading" @click="confirm" size="small" backGroundColor="linear-gradient( 90deg, #164FF9 0%, #1870FF 100%)">{{ confirmButtonText }}</TsaButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TsaButton from '@/components/copyright/basics/button'
export default {
    components: {
        TsaButton
    },
    data () {
        return {
            show: false,
            title: '生成版权认证证书',
            name: '',
            free: false, // 默认需要付费
            loading: false,
            cancelButtonText: '',
            confirmButtonText: '',
            tsCount: 0,
            minFileTsCount: 0,
            // 英文证书
            englishCertificate: 'https://tsa-content.oss-cn-beijing.aliyuncs.com/certificateSample/zscq_bq2.jpg?t=' + new Date().getTime(),
            // 中文证书
            chineseCertificate: 'https://tsa-content.oss-cn-beijing.aliyuncs.com/certificateSample/zscq_bq1.jpg?t=' + new Date().getTime(),
        }
    },
    watch: {
        show (val) {
            if (!val) {
                this.onClose = null
                this.onCancel = null
                this.onConfirm = null
                this.loading = false
                this.tsCount = 0
                this.minFileTsCount = 0
            }
        }
    },
    beforeDestroy () {
        this.customViewerApi && this.customViewerApi.hide()
    },
    methods: {
        open ({ free=false, name = '', minFileTsCount, tsCount, onClose, onCancel, onConfirm} = {}) {
            this.show = true
            this.free = free
            this.name = name
            this.minFileTsCount = minFileTsCount
            this.tsCount = tsCount
            this.onClose = onClose
            this.onCancel = onCancel
            this.onConfirm = onConfirm
            this.setButtonText(free)
        },
        hide () {
            this.show = false
        },
        setButtonText (free) {
            this.cancelButtonText = '我再想想'
            this.confirmButtonText = free ? '确认申请' : '确认申请'
        },
        close () {
            if (this.onClose) {
                this.onClose && this.onClose(this)
            } else {
                this.show = false
            }
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightGenerate, {
                '操作类型': '消费_取消/关闭'
            })
            
        },
        cancel () {
            if (this.onCancel) {
                this.onCancel && this.onCancel(this)
            } else {
                this.show = false
            }
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightGenerate, {
                '操作类型': '消费_取消/关闭'
            })
        },
        confirm () {
            if (this.onConfirm) {
                this.onConfirm && this.onConfirm(this)
            } else {
                this.show = false
            }
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightGenerate, {
                '操作类型': '消费_确认申请'
            })
        },
        preview (url) {
            this.customViewerApi = this.$viewerApi({
                images: [url],
                options: {
                    title: false,
                    toolbar: false,
                    navbar: false,
                    button: false,
                    viewed() {
                        var that = this
                        document.querySelector('.viewer-container .viewer-canvas').onclick = function (e) {
                            if (e.target.className === 'viewer-canvas') {
                                that.viewer.hide()
                            }
                        }
                    }
                    // button: false
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .tsa-certificateServiceFeeDialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, .5);
        }
        .content {
            width: 90%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #FFFFFF;
            box-shadow: 0px 4px 12px 1px rgba(7,12,20,0.12);
            border-radius: 12px;
            padding: 24px;
            padding-top: 32px;
            box-sizing: border-box;
            .close {
                position: absolute;
                top: 15px;
                right: 15px;
                font-size: 24px;
                color: #999999;
                cursor: pointer;
                &:hover {
                    color: #2468F2;
                }
            }
            .top {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 20px;
                img {
                    width: 50px;
                    height: 26px;
                    margin-left: 16px;
                }
                p {
                    font-weight: bold;
                    font-size: 20px;
                    color: #000000;
                    text-align: center;
                }
            }
            .center {
                margin-bottom: 24px;
                .certificate-container {
                    display: flex;
                    justify-content: center;
                    margin-bottom: 24px;
                    .item {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        cursor: pointer;
                        img {
                            width: 150px;
                            height: 205px;
                            margin-bottom: 7px;
                        }
                        p {
                            font-size: 16px;
                            color: #666666;
                        }
                        &:last-child {
                            margin-left: 16px;
                        }
                    }
                }
                .free-container {
                    p {
                        font-size: 16px;
                        color: #333333;
                        text-align: justify;
                        span {
                            font-size: 16px;
                            color: #FF383C;
                        }
                    }
                }
                .pay-container {
                    p {
                        font-size: 16px;
                        color: #333333;
                        &:first-child {
                            margin-bottom: 8px;
                        }
                    }
                }
            }
            .btn-group {
                display: flex;
                justify-content: flex-end;
                .btn {
                    width: 98px;
                    margin-left: 12px;
                }
            }
        }
    }
</style>